import { PostTypes } from 'constants/postTypes'
import React from 'react'

import { DiscardChangesModal } from 'pages/WorkoutEditor/subcomponents/DiscardChangesModal'

import { DeletePostModal } from 'partials/DeletePostModal'
import { NavMenuButton } from 'partials/MobileNav/types'
import { Page } from 'partials/Page'
import { PostEditorForm } from 'partials/PostEditorForm'

import { Box } from 'widgets/Box'
import { Toast as ToastComponent } from 'widgets/Toast'

import { useWorkoutEditor } from 'hooks/useWorkoutEditor'

import { links } from 'utils/constants'

export const PostEditorPage = ({ navigation, route }: any) => {
  const isEditing = route?.name === links.EDIT_WORKOUT_PAGE
  const postId = route?.params?.postId

  const {
    postFormData,
    createPostLoading,
    editPostLoading,
    closeDeleteModal,
    saveMultipleSteps,
    deleteStepAtIndex,
    discardChanges,
    handlePublish,
    saveDetails,
    closeDiscardModal,
    openModalName,
  } = useWorkoutEditor({ postType: PostTypes.POST, isEditing, postId })

  const shareNavButton: NavMenuButton = {
    title: 'Share',
    onPress: handlePublish,
  }

  return (
    <>
      <Page
        withBack
        withNav
        title='Start Post'
        backgroundColor='white'
        navbarRightButtons={[shareNavButton]}
        isLoading={createPostLoading || editPostLoading}
        navigation={navigation}
      >
        <Box flex={1}>
          <PostEditorForm
            postFormData={postFormData}
            saveMultipleSteps={saveMultipleSteps}
            deleteStepAtIndex={deleteStepAtIndex}
            saveDetails={saveDetails}
          />
          <ToastComponent />
        </Box>
      </Page>

      {postId && (
        <DeletePostModal
          handleClose={closeDeleteModal}
          isOpen={openModalName === 'delete'}
          postId={postId}
        />
      )}
      <DiscardChangesModal
        handleClose={closeDiscardModal}
        handleDiscard={discardChanges}
        isVisible={openModalName === 'discardChanges'}
      />
    </>
  )
}
